import React from 'react';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import EditPatient from 'components/templates/admin/patientEdit';

const AdminPatientEdit = () => (
  <Container>
    <AdminHeader />
    <EditPatient />
  </Container>
);

export default AdminPatientEdit;
